module.exports = __webpack_public_path__ + "img/logo-new.493d2a19.png";